export const makeApiUrl = (url: string): string => {
  return window.location.origin.includes("localhost") ? 'https://krcbor.glassen-it.com/api/v1' : window.location.origin + '/api/v1'
}
